import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import * as $ from "jquery";

@Injectable({
  providedIn: 'root'
})
export class RoutesGuard implements CanActivate {
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      // console.log('toco esto?');
      $('#personalizedParallax').html('');
      setTimeout(()=>{
        document.getElementById('loading').classList.remove("hide");
        document.getElementById('loading').classList.remove("hideLoad");
        document.getElementById('loadingAnimation').classList.remove("rotateOut");
      },200)

      return true;

  }
  
}
